'use strict';

VideoChatController.$inject = [
  'ready',
];

export function VideoChatController(
  ready,
) {
  const vm = this;
  vm.props = {};
}



// WEBPACK FOOTER //
// ./src/js/comments/controllers/VideoChatController.js